"use strict";

import Vue from 'vue';
import axios from "axios";
import router from '../router/index.js';
import $store from '../store/index.js';
import {host, resolveApiUrl} from '../config/request.js';
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
let config = {
  baseURL: process.env.NODE_ENV==='development'?'/api':host
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const Plugin = {};
const _axios = axios.create(config);
// 请求拦截器
_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
	if(config.token === true){
		config.headers['token'] = window.localStorage.getItem('token')
	}
	if (process.env.NODE_ENV !== 'development' && config.url) {
		config.url = resolveApiUrl(config.url)
	}
	console.log(config)
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// 响应拦截器
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
	if ($store.state.user.center_id && response.data && response.data.time) {
		window.localStorage.setItem('timestamp_'+$store.state.user.center_id,response.data.time)
	}
	console.log(response)
	if(response.data.code === 0){
		return response.data;
	}else{
		console.log(response)
		if(response.data.code ==-9999 || response.data.code===200 ){
			$store.dispatch('logout').then(res=>{
				router.push({name:'login'})
				Vue.prototype.$message.error('请登录后操作!')
			}) 
		}else{
			Vue.prototype.$message.error(response?(response.data?response.data.msg:'服务器异常!'):'服务器异常!')
		}
		return {code:400,data:null}
	}
	
  },
  function(error) {
    // Do something with response error
	// 全局错误提示
	console.log(error)
	let status = error && error.response ? error.response.status : null
	if(status == 500){
		Vue.prototype.$message.error('服务器异常!')
	} else if (!status) {
		Vue.prototype.$message.error('网络连接异常，请清理浏览器缓存后重试')
	}
	
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {  
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default _axios;
